import { _js } from '@ifixit/localize';
import { connect } from 'react-redux';

const mapStateToProps = (state: any) => ({
   products: state.headerState.miniCart.products,
});

const Body = ({ products }: { products: any[] }) => {
   if (!products.length) {
      return <p className="mini-cart-empty-message">{_js('Looks like your cart is empty')}</p>;
   }

   return (
      <div className="mini-cart-products-container">
         <ul className="mini-cart-products">
            {products.map((product: any, index: any) => (
               <li className="mini-cart-product" key={index}>
                  <img
                     className="mini-cart-product-image"
                     src={product.imageUrl}
                     alt={product.displayName}
                  />
                  <div className="mini-cart-product-info">
                     <a
                        className="mini-cart-product-title"
                        href={product.url}
                        title={product.displayName}
                     >
                        {product.shortDisplayName}
                     </a>
                     <span className="mini-cart-product-variant">{product.variantName}</span>
                     <span className="mini-cart-product-price">
                        {`${product.quantity} × ${product.priceText}`}
                     </span>
                  </div>
               </li>
            ))}
         </ul>
      </div>
   );
};

export default connect(mapStateToProps)(Body);
